// extracted by mini-css-extract-plugin
export default {"linksBoxTitle":"MatrixBox_linksBoxTitle__vZYik","number":"MatrixBox_number__ZgSe-"};